import moment, { Moment } from 'moment'

export const formatDate = (date?: string | Moment) => {
  if (date) {
    return moment(date).format('YYYY-MM-DD(ddd) HH:mm')
  }
  return null
}
